import React from 'react';
import PropTypes from 'prop-types';

const GreetingHeader = ({ name }) => {
  const today = new Date();

  const formattedDate = today.toLocaleDateString('en-US', {
    weekday: 'long',
    month: 'long',
    day: 'numeric',
  });

  const hour = today.getHours();
  let greeting;
  if (hour < 12) greeting = 'Good morning';
  else if (hour < 18) greeting = 'Good afternoon';
  else greeting = 'Good evening';

  // Titles to detect
  const titles = ['Dr.', 'Dr', 'Mr.', 'Mr', 'Mrs.', 'Mrs', 'Ms.', 'Ms', 'Prof.', 'Prof'];

  const nameParts = name?.trim().split(' ') || [];

  let title = '';
  let firstName = '';

  if (nameParts.length > 0) {
    if (titles.includes(nameParts[0])) {
      // first part is a title
      title = nameParts[0];
      firstName = nameParts[1] || '';
    } else {
      // no title
      firstName = nameParts[0];
    }
  }

  const displayName = title ? `${title} ${firstName}` : firstName;

  return (
    <div className="greetings">
      <h2>{formattedDate}</h2>
      <h3>
        {greeting}, {displayName}!
      </h3>
    </div>
  );
};

GreetingHeader.propTypes = {
  name: PropTypes.string.isRequired,
};

export default GreetingHeader;
